import { createUrl, getObject, getObjects, patchObject, postObject, putObject, REACT_APP_API_URL } from "../Common/js/api_common"

export const ENDPOINT_CHARACTERISTICS = "/api/characteristics"

export async function getCharacteristics(parameters = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_CHARACTERISTICS
  const defaultParameters = {}
  url = createUrl(url, parameters, defaultParameters)
  return await getObjects(url)
}

export async function getCharacteristic(id) {
  let url = REACT_APP_API_URL + ENDPOINT_CHARACTERISTICS + "/" + id
  return await getObject(url)
}

export async function putCharacteristic(id, putValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_CHARACTERISTICS + "/" + id
  return await putObject(url, putValues)
}

export async function patchCharacteristic(id, patchValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_CHARACTERISTICS + "/" + id
  return await patchObject(url, patchValues)
}

export async function postCharacteristic(postValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_CHARACTERISTICS
  return await postObject(url, postValues)
}
